/**
 * SHER-327: trim leading/trailing whitespace from patient personal fields on save.
 */
import { IField } from '../constants/types';
import { trimSearchValue } from './trimSearchValue';

const SKIP_TRIM_FIELDS = new Set(['automated_health_id', 'birthdate', 'coverage']);

function shouldTrimField(field: IField | undefined): boolean {
    if (!field) return false;
    if (SKIP_TRIM_FIELDS.has(field.name)) return false;
    if (field.type === 'date' || field.type === 'hidden') return false;
    if (field.options && field.options.length > 0) return false;
    return true;
}

/**
 * Normalizes raw redux-form values before encryption/API submit.
 * Mutates `data` in place and returns it for convenience.
 */
export function normalizePatientFormValues(
    data: Record<string, unknown>,
    fields: IField[],
): Record<string, unknown> {
    const fieldByName = new Map(fields.map((field) => [field.name, field]));

    for (const [key, value] of Object.entries(data)) {
        if (!shouldTrimField(fieldByName.get(key))) continue;
        if (typeof value === 'string') {
            data[key] = trimSearchValue(value);
        }
    }

    return data;
}

/**
 * Normalizes decrypted personalData object used in local Dexie storage / display.
 */
export function normalizePatientPersonalData(
    personalData: Record<string, unknown>,
    fields: IField[],
): Record<string, unknown> {
    return normalizePatientFormValues(personalData, fields);
}
